import React, { useEffect, useState } from "react";
import { Container, Box, Typography } from "@mui/material";
import CustomBreadcrumbs from "../../common/components/breadcrumb-component-new/breadcrumb-component-new";
import { useLocation } from "react-router-dom";
import PayByForm from "./components/PayByForm";
import PriceDetails from "./components/PriceDetails";
import { getOrderSummaryById } from "../../api/order-summary.api";
import "./payment-page.scss";

const PaymentPage = () => {
  const location = useLocation();

  const [orderId, setOrderId] = useState<number>(
    location?.state?.orderSummary?.orderId ?? location?.state?.orderId
  );
  const isFromPlans = location.state?.isFromPlans ?? false;
  const plannerId = location.state?.plannerId;
  const partnerId = location?.state?.partnerId;
  const isFromCartPage = location?.state?.isFromCartPage;
  const retryClientSecret = location.state?.clientSecret;

  const [orderSummary, setOrderSummary] = useState<any>();
  const immediateNeedTotal = location.state?.immediateNeedTotal;


  const fetchOrderSummary = async () => {
    try {
      const response = await getOrderSummaryById(orderId);

      setOrderSummary(response.data?.data?.data?.orders);
    } catch (error) {
      console.error("ERROR ORDER SUMMARY::", error);
    }
  };

  const breadcrumbsFromCart = [
    { label: "Selected Services", to: "/cart" },
    {
      label: "Order summary",
      to: "/order-summary",
      state: {
        orderId: orderId,
        isBackFromPaymentPg: true,
        partnerId: partnerId,
        isFromPlans: isFromPlans,
        plannerId: plannerId,
      },
    },
    { label: "Payment" },
  ];

  const breadcrumbsDefault = [
    { label: "Home", to: "/home" },
    { label: "List", to: "/home/list-of-funeral-homes" },
    {
      label: "Detail page",
      to: isFromPlans
        ? `/home/list-of-funeral-homes/preneed-planners/${plannerId}`
        : `/home/list-of-funeral-homes/details/${partnerId}`,
    },
    {
      label: "Order summary",
      to: "/order-summary",
      state: {
        orderId,
        partnerId: partnerId,
        isFromPlans: isFromPlans,
        plannerId: plannerId,
      },
    },
    { label: "Payment" },
  ];

  useEffect(() => {
    fetchOrderSummary();
  }, []);

  return (
    <Container className="payment-page">
      <div className="payment-page__breadcrumbs">
        <CustomBreadcrumbs
          items={isFromCartPage ? breadcrumbsFromCart : breadcrumbsDefault}
        />
      </div>

      <Box className="payment-page__content">
        <Box className="payment-page__left">
          <Typography className="payment-page__payment-heading">
            Payment Method
          </Typography>
          <PayByForm
            grandTotal={
              (isFromPlans || (orderSummary?.partners && orderSummary?.partners.length > 0 && orderSummary?.partners.every((p: any) => !!p.plannerId || Array.isArray(p?.packages))))
                ? orderSummary?.summary?.grandTotal 
                : (immediateNeedTotal || orderSummary?.summary?.grandTotal)
            }
            orderId={orderSummary?.orderId}
            retryClientSecret={retryClientSecret}
          />

        </Box>

        <Box className="payment-page__right">
          <PriceDetails 
            orderSummary={{ ...orderSummary?.summary, partnerList: orderSummary?.partners }} 
            isFromPlans={isFromPlans}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default PaymentPage;
